
export default [

        {
            path:'/zhanhui',
            name:'zhanhui',
            component:() => import('@/views/zhanhui/zhanhui'),
            meta: {
    
                keepAlive: true, //此组件需要被缓存
                isBack:false,
            }
        },
        
]


// WEBPACK FOOTER //
// ./src/router/zhanhui.js